import { NotificationData, notifications } from "@mantine/notifications";
import React, { ReactNode } from "react";

enum NotificationColor {
  success = "green",
  error = "red",
  warning = "yellow",
  info = "blue",
  primary = "blue",
}

export type Appearance = "success" | "error" | "warning" | "info" | "primary";

const baseStyles = {
  title: { color: "var(--dark)", fontFamily: "unset" },
  description: { color: "var(--dark)", fontFamily: "unset" },
  closeButton: {
    color: "var(--dark)",
    "&:hover": { backgroundColor: "var(--medium)", color: "white" },
  },
};

const successStyles = {
  root: {
    backgroundColor: "var(--dropdown-selected)",
    borderColor: "var(--dropdown-selected-dark)",

    "&::before": { backgroundColor: "var(--primary)" },
  },
  ...baseStyles,
};

const errorStyles = {
  root: {
    backgroundColor: "#FFD8D8",
    borderColor: "var(--danger)",
    "&::before": { backgroundColor: "var(--danger)" },
  },
  ...baseStyles,
};

const warningStyles = {
  root: {
    backgroundColor: "#FFDEBF",
    borderColor: "var(--warning)",
    "&::before": { backgroundColor: "var(--warning)" },
  },
  ...baseStyles,
};

const primaryStyles = {
  root: {
    "&::before": { backgroundColor: "var(--success)" },
  },
  ...baseStyles,
};

const infoStyles = {
  root: {
    backgroundColor: "#C2DEEB",
    borderColor: "var(--info)",
    "&::before": { backgroundColor: "var(--info)" },
  },
  ...baseStyles,
};

const styles = {
  success: successStyles,
  error: errorStyles,
  warning: warningStyles,
  primary: primaryStyles,
  info: infoStyles,
};

const SuccessIcon: ReactNode = React.createElement("i", {
  className: "mdi mdi-check-bold",
});

export const newToastEvent = (
  appearance: Appearance = "primary",
  message: ReactNode,
  id?: string,
  additionalOptions?: Omit<NotificationData, "message">
) => {
  notifications.show({
    id: id ?? undefined,
    message: message,
    color: NotificationColor[appearance],
    ...additionalOptions,
    styles: styles[appearance],
    icon: appearance === "success" ? SuccessIcon : null,
  });
};

export const updateToastEvent = (
  appearance: Appearance = "primary",
  message: ReactNode,
  id: string,
  additionalOptions?: Omit<NotificationData, "message">
) => {
  notifications.update({
    id: id,
    message: message,
    color: NotificationColor[appearance],
    ...additionalOptions,
    styles: styles[appearance],
    icon: appearance === "success" ? SuccessIcon : null,
  });
};

export const hideToast = (id: string) => {
  notifications.hide(id);
};
